// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2onaz","consentsList":"PatientConsents_consentsList__3eUNz","consentsListEmpty":"PatientConsents_consentsListEmpty__1o8Q1"};